function getPlayerPositionsMap(positions: number[], sportConfig: object): object {
    const playerPositionsMap = {};

    positions.map((positionNumber: number) => {
        // @ts-ignore
        const positionName = sportConfig.getPositionName(positionNumber);

        playerPositionsMap[positionName] = positionNumber;
    });

    return playerPositionsMap;
}

export function getSelectablePositionsMap(positions: number[], sportConfig: object): object {
    const playerPositionsMap = getPlayerPositionsMap(positions, sportConfig);

    const selectablePositionsMap = {};

    const positionNames: string[] = Object.keys(playerPositionsMap);

    if (positionNames.length > 1) {
        selectablePositionsMap[positionNames.sort().join('/')] = Object.values(playerPositionsMap);
    }

    positionNames.map((positionName) => {
        selectablePositionsMap[positionName] = [playerPositionsMap[positionName]];
    });

    return selectablePositionsMap;
}

interface OriginalPosition {
    readonly slug: string;
    readonly numbers: number[];
}

export function createOriginalPosition(player): OriginalPosition {
    return {
        slug: player.positionName,
        numbers: player.position,
    };
}
